// notifications/back-in-stock.schema.ts
import { z } from "zod";
var BackInStockStatusSchema = z.enum(["pending", "notified", "cancelled"]);
var DbBackInStockSubscriptionSchema = z.object({
  id: z.string().uuid(),
  customer_id: z.string().uuid(),
  product_id: z.string().uuid(),
  notification_email: z.string().email(),
  status: BackInStockStatusSchema,
  source_host_domain: z.string().min(1),
  source_embed_config_id: z.number().int().nullable(),
  unsubscribe_token_jti: z.string().min(1),
  cancellation_reason: z.string().nullable(),
  created_at: z.union([z.string(), z.date()]),
  notified_at: z.union([z.string(), z.date()]).nullable(),
  cancelled_at: z.union([z.string(), z.date()]).nullable()
});
var BackInStockSubscriptionSchema = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  productId: z.string().uuid(),
  b2bwaveProductId: z.number().int().nullable(),
  notificationEmail: z.string().email(),
  status: BackInStockStatusSchema,
  sourceHostDomain: z.string().min(1),
  sourceEmbedConfigId: z.number().int().nullable(),
  unsubscribeTokenJti: z.string().min(1),
  cancellationReason: z.string().nullable(),
  createdAt: z.date(),
  notifiedAt: z.date().nullable(),
  cancelledAt: z.date().nullable()
});
var BackInStockSubscriptionDtoSchema = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  productId: z.string().uuid(),
  b2bwaveProductId: z.number().int().nullable(),
  notificationEmail: z.string().email(),
  status: BackInStockStatusSchema,
  sourceHostDomain: z.string().min(1),
  sourceEmbedConfigId: z.number().int().nullable(),
  cancellationReason: z.string().nullable(),
  createdAt: z.string().datetime(),
  notifiedAt: z.string().datetime().nullable(),
  cancelledAt: z.string().datetime().nullable()
});
var CancellationReasonSchema = z.enum([
  "user",
  "email_invalid",
  "customer_inactive",
  "product_removed",
  "admin"
]);
export {
  BackInStockStatusSchema,
  BackInStockSubscriptionDtoSchema,
  BackInStockSubscriptionSchema,
  CancellationReasonSchema,
  DbBackInStockSubscriptionSchema
};
